import React from 'react';
import { array, bool, string } from 'prop-types';
import css from './SeoDiscovery.module.css';

const SeoUpcomingEvents = props => {
  const {
    ctaLabel = 'Buy Tickets',
    emptyMessage,
    events,
    id,
    intro,
    showImages = true,
    title,
    venueName,
  } = props;
  const heading = title || `Upcoming Events at ${venueName}`;

  if (!events?.length) {
    return (
      <section className={css.section} id={id || undefined}>
        <h2>{title || 'Upcoming Events'}</h2>
        <p>
          {emptyMessage ||
            `There are no live listings at ${venueName} right now. Check back soon or browse events on PromoTix.`}
        </p>
      </section>
    );
  }
  return (
    <section className={css.section} id={id || undefined}>
      <h2>{heading}</h2>
      {intro ? <p>{intro}</p> : null}
      <ul className={css.eventList}>
        {events.map(ev => (
          <li key={ev.listingId || ev.path} className={css.eventItem}>
            {showImages && ev.imageUrl ? (
              <a
                className={css.eventThumbLink}
                href={ev.path || '#'}
                aria-label={ev.title}
                tabIndex={ev.path ? undefined : -1}
              >
                <img className={css.eventThumb} src={ev.imageUrl} alt="" loading="lazy" />
              </a>
            ) : null}
            <div className={css.eventContent}>
              {ev.path ? (
                <a href={ev.path}>{ev.title}</a>
              ) : (
                <span>{ev.title}</span>
              )}
              <div className={css.eventMeta}>
                {ev.eventDateDisplay}
                {ev.venueName ? ` · ${ev.venueName}` : null}
                {ev.priceFrom != null ? ` · From $${ev.priceFrom}` : null}
              </div>
            </div>
            {ev.path ? (
              <a className={css.eventCta} href={ev.path}>
                {ctaLabel}
              </a>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
};

SeoUpcomingEvents.propTypes = {
  ctaLabel: string,
  emptyMessage: string,
  events: array,
  id: string,
  intro: string,
  showImages: bool,
  title: string,
  venueName: string,
};

export default SeoUpcomingEvents;
